module.exports = __webpack_public_path__ + "static/media/step-1-island.d63aabb9.gif";